var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-object-listing" },
    [
      _c("v-object-listing-data-provider", {
        attrs: {
          "object-type": _vm.objectType,
          "api-url": _vm.apiUrl,
          "default-image-url": _vm.defaultImageUrl
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(dataProvider) {
              return _c("div", { staticClass: "o-grid" }, [
                _c(
                  "div",
                  {
                    staticClass: "c-object-listing__utilities o-grid__column",
                    attrs: {
                      "data-size": "sm:12",
                      "data-layout": "spacious",
                      id: "utilities"
                    }
                  },
                  [
                    _c("div", [
                      !dataProvider.isLoading
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "t-text-style-epsilon t-margin--2-bottom"
                            },
                            [
                              _vm._v("Visar "),
                              _c(
                                "span",
                                { staticClass: "t-text-color--emphasis" },
                                [
                                  _vm._v(
                                    _vm._s(dataProvider.currentObjects.length)
                                  )
                                ]
                              ),
                              _vm._v(" " + _vm._s(_vm.objectTypeDisplay))
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      dataProvider.filtersApplied &&
                      dataProvider.currentObjects.length === 0
                        ? _c(
                            "a",
                            {
                              staticClass: "t-reset-link",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return dataProvider.resetAllFilters($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.resetAllText) +
                                  "\n\t\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "c-object-listing__utilities c-object-listing__filtersarea o-grid__column",
                    attrs: { "data-size": "sm:12" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "c-object-listing__multiselectarea" },
                      [
                        _vm._l(dataProvider.multiSelectFilters, function(
                          filter,
                          index
                        ) {
                          return [
                            filter && filter.items && filter.items.length > 0
                              ? _c("v-multi-select-development", {
                                  key: "multiselect-" + index,
                                  attrs: {
                                    label: filter.displayName,
                                    id: filter.name,
                                    options: filter.items
                                  },
                                  on: {
                                    optionSelected:
                                      dataProvider.setMultiSelectFilter
                                  }
                                })
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  ]
                ),
                _vm._v(" "),
                dataProvider.isLoading
                  ? _c(
                      "div",
                      {
                        staticClass: "c-loading o-grid__column",
                        attrs: { "data-size": "sm:12" }
                      },
                      [
                        _c("div", { staticClass: "c-loading__circle" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "c-loading__text" }, [
                          _vm._v(_vm._s(_vm.loadingText))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "o-grid__column",
                    attrs: { "data-size": "sm:12" }
                  },
                  [
                    !dataProvider.isLoading
                      ? _c(
                          "div",
                          { staticClass: "o-grid" },
                          _vm._l(dataProvider.currentObjects, function(
                            object,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "o-grid__column o-grid__column--heightauto",
                                attrs: {
                                  "data-layout": "spacious",
                                  "data-size": "sm:12 md:4"
                                }
                              },
                              [
                                _c("v-object-development", {
                                  attrs: {
                                    image: object,
                                    readMoreLabel: "Läs mer"
                                  }
                                })
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              ])
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }